import { render, staticRenderFns } from "./InsurerListView.vue?vue&type=template&id=5271b31a&scoped=true"
import script from "./InsurerListView.vue?vue&type=script&lang=js"
export * from "./InsurerListView.vue?vue&type=script&lang=js"
import style0 from "./InsurerListView.vue?vue&type=style&index=0&id=5271b31a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271b31a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5271b31a')) {
      api.createRecord('5271b31a', component.options)
    } else {
      api.reload('5271b31a', component.options)
    }
    module.hot.accept("./InsurerListView.vue?vue&type=template&id=5271b31a&scoped=true", function () {
      api.rerender('5271b31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerListView.vue"
export default component.exports